import requests from "./httpService";

const IPAddressServices = {
  getIPAddress(id, body) {
    return requests.get(`/ipaddress/all?company_id=${id}`, body);
  },

  deleteIPAddress(id, body) {
    return requests.delete(`/ipaddress/${id}`, body);
  },
  createIPAddress(body) {
    return requests.post(`/ipaddress/create`, body);
  },
  editIPAddress(id, body) {
    return requests.post(`/ipaddress/update/${id}`, body);
  },
};

export default IPAddressServices;
